module.exports = { 
    AppName : 'Wallpeppers', 
    AppVersion : 'v2.4', 
    primaryTheme : 'dark',
    glassmorphism: true,
    blur: '64px',

    // WALLPAPER LIST STYLING
    wallpaperBorderRadius: 8,
    wallpaperMargin: 4,
    
    // DARK THEME COLORS
    primaryAccentDark: '#DD1717',
    primaryAccentTextDark: '#000000',
    secondaryAccentDark: '#424242',
    secondaryAccentTextDark: '#000000',
    backgroundDark: '#000000',
    themeDark: '#00000080', //Top & Bottom Bars Keep this as close to the background, if not same

    // LIGHT THEME COLORS
    primaryAccentLight: '#0060bf',
    primaryAccentTextLight: '#ffffff',
    secondaryAccentLight: '#ffffff',
    secondaryAccentTextLight: '#87c3ff',
    backgroundLight: '#ffffff',
    themeLight: '#ffffff80', //Top & Bottom Bars Keep this as close to the background, if not same
};